import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Badge, Box, Column, Row, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import styles from './AgreementItem.module.scss';
import { RecentAgreementMenu } from './RecentAgreementMenu';
import { useRecentAgreementNavigation } from './useRecentAgreementNavigation';
export const GetAgreementItemTID = (parentTestId)=>getTestIds(parentTestId);
export function AgreementItem(param) {
    let { row, customerId, customerName, isArchived, refetch, optimisticallyRemove, testId } = param;
    const { AgreementItemTestIds: TID } = useMemo(()=>GetAgreementItemTID(testId), [
        testId
    ]);
    const onClickRow = useRecentAgreementNavigation();
    return /*#__PURE__*/ _jsx(Box, {
        testId: testId,
        className: styles.row,
        onClick: onClickRow(row),
        children: /*#__PURE__*/ _jsxs(Row, {
            gap: 12,
            alignItems: "center",
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ _jsxs(Column, {
                    gap: 8,
                    className: styles.titleColumn,
                    children: [
                        /*#__PURE__*/ _jsxs(Row, {
                            gap: 4,
                            alignItems: "center",
                            className: styles.titleRow,
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    testId: TID.Title(),
                                    variant: "paragraph2",
                                    skin: "primary",
                                    ellipsis: true,
                                    children: row.title
                                }),
                                /*#__PURE__*/ _jsx(Box, {
                                    className: styles.badge,
                                    children: /*#__PURE__*/ _jsx(Badge, {
                                        testId: TID.Badge(),
                                        "data-skin": row.badgeSkin,
                                        skin: row.badgeSkin,
                                        size: "small",
                                        rounded: true,
                                        outlined: true,
                                        children: row.badgeLabel
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            testId: TID.SecondaryLine(),
                            variant: "paragraph3",
                            skin: "secondary",
                            children: row.secondaryLine
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Box, {
                    className: styles.kebab,
                    onClick: (event)=>event.stopPropagation(),
                    children: /*#__PURE__*/ _jsx(RecentAgreementMenu, {
                        row: row,
                        customerId: customerId,
                        customerName: customerName,
                        isArchived: isArchived,
                        refetch: refetch,
                        optimisticallyRemove: optimisticallyRemove,
                        testId: TID.Menu()
                    })
                })
            ]
        })
    });
}
